import { useArticleInfoQuery } from "@api/articleInfo/useArticleInfo";

export const useDisabledPublishButton = () => {
  const { data: articleInfo } = useArticleInfoQuery();

  const disabledNextButton = !articleInfo?.imagePath;

  return disabledNextButton;
};
